export const addNewAttendanceShiftSuccess = 'ADD_NEW_ATTENDANCE_SHIFT_SUCCESS';
export const addNewAttendanceShiftFailure = 'ADD_NEW_ATTENDANCE_SHIFT_FAILURE';
export const getAllAttendanceShiftSuccess = 'GET_ALL_ATTENDANCE_SHIFT_SUCCESS';
export const getAllAttendanceShiftFailure = 'GET_ALL_ATTENDANCE_SHIFT_FAILURE';
export const editAttendanceShiftSuccess = 'EDIT_ALL_ATTENDANCE_SHIFT_SUCCESS';
export const editAttendanceShiftFailure = 'EDIT_ALL_ATTENDANCE_SHIFT_FAILURE';
export const deleteAttendanceShiftSuccess = 'DELETE_ALL_ATTENDANCE_SHIFT_SUCCESS';
export const deleteAttendanceShiftFailure = 'DELETE_ALL_ATTENDANCE_SHIFT_FAILURE';